module.exports = __webpack_public_path__ + "img/mingyong48.c7223509.png";